module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-kanto-2-7c4b31e55f8c0e1e9ac89a84b5c82731.png";